import { registerFeatureWithDescription } from "lib/features"
import { FEATURE_FLAG_ARCHIVE_WORK_PACKAGES } from "authoring/lib/enum/authoring-feature-flags.mjs"

registerFeatureWithDescription({
    numericalId: 5005,
    id: FEATURE_FLAG_ARCHIVE_WORK_PACKAGES,
    name: "Archive work packages",
    internalUseOnly: true,
    descriptionLines: [
        "Lets permitted users archive and restore work packages.",
        "Archived work packages are read-only and keep their amends documents and review cycles.",
    ],
})

export { FEATURE_FLAG_ARCHIVE_WORK_PACKAGES }
